<template>
	<div class="lite-lock">
		<img
			class="lite-lock__image"
			src="@/assets/images/illustrations/lite-unlock.png"
			alt=""
			width="250"
			height="250"
		/>
		<div class="lite-lock__copy">
			<h2 class="lite-lock__title">
				{{ title || 'Mở khóa tính năng với Luca Pro' }}
			</h2>
			<p class="lite-lock__desc">
				{{
					description ||
					'Nâng cấp lên Luca Pro để sử dụng đầy đủ các tính năng quản lý và vận hành cơ sở.'
				}}
			</p>
		</div>
		<router-link
			v-if="isAdmin"
			class="button-p btn--ghost lite-lock__button"
			:to="{ name: routerName.PACKAGE_BUYING_PACKAGE }"
		>
			Nâng cấp lên Luca Pro
		</router-link>
	</div>
</template>

<script>
import { _ROUTER_NAME } from '@/enums';

export default {
	name: 'LiteFeatureLock',
	props: {
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
	},
	computed: {
		routerName() {
			return _ROUTER_NAME;
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},
};
</script>

<style lang="scss" scoped>
.lite-lock {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 64px 48px 80px;
}

.lite-lock__image {
	width: 250px;
	height: 250px;
	object-fit: contain;
}

.lite-lock__copy {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	margin-top: 24px;
	text-align: center;
}

.lite-lock__title {
	max-width: 736px;
	color: #48566a;
	font-size: 23px;
	font-weight: 600;
	line-height: 28px;
	letter-spacing: -0.46px;
}

.lite-lock__desc {
	max-width: 606px;
	color: #94a3b8;
	font-size: 18px;
	font-weight: 400;
	line-height: 24px;
}

.lite-lock__button {
	width: auto;
	height: 44px;
	margin-top: 40px;
	padding: 12px 20px;
}
</style>
